import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase, RentalObjectInfo, ObjectTypeInfo } from 't4core';
import { AppTypeSettings, AppSettingsService } from 't4-app-integration';

export type ViewActionsDisplayMode = 'primary' | 'white' | 'transparent';

@Component({
    selector: 'view-actions',
    templateUrl: './view-actions.html',
    styleUrls: ['./view-actions.css'],
    standalone: false
})
export class ViewActionsComponent extends ComponentBase implements OnInit {

  public typeSettings: AppTypeSettings;
  @Input() public mode: ViewActionsDisplayMode = 'primary';
   
  constructor() {
    super();
  }
   
  ngOnInit(): void {
  }

}
